import React from 'react'
import background from '../../Assets/Hero/home_empowering.png'

function Empowering() {
    return (
        <div
            className="w-full bg-white"
        >
            <div className="mx-auto max-w-[1640px] lato z-10 relative py-[10rem] md:py-[15rem] h-full flex items-center justify-center"
                style={{
                    backgroundImage: `url(${background})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    minHeight: 'auto',
                }}>
                <div className='p-[1rem] md:p-[2rem]'>
                    <p
                        style={{ fontSize: 'clamp(30px,4.5vw,70px)' }}
                        className='text-white uppercase font-extrabold text-center'>
                        Empowering your digital future
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Empowering
